import * as React from "react";
const SvgClose = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, stroke: "#1A1B1E", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18 6 6 18M6 6l12 12" }));
export default SvgClose;
